module.exports = __webpack_public_path__ + "f0e79047664c28767b9fb093ad818176.png";